/* eslint-disable no-empty */
import axios from "axios";
import { debounce } from "lodash";
import store from "@/store/index";
import router from "@/router/index";
import { Message } from "@xt-fe/xt-components";
import { refreshToken } from "@/api/login";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 40000,
});
let isExchangingToken = false;
let exchangePromise = null;
const limitRefreshTokenMinutes = 30; // 限制刷新 Token 的最小时间间隔（分钟）

const handleExchangeToken = async () => {
  try {
    if (isExchangingToken) {
      // 如果有 Token 交换正在进行，则等待其完成
      await exchangePromise;
      return;
    }
  } catch (error) {
    console.error(error);
  }
  try {
    isExchangingToken = true;
    // eslint-disable-next-line no-async-promise-executor
    exchangePromise = new Promise(async (resolve, reject) => {
      try {
        const formData = new FormData();
        formData.append("refreshToken", localStorage.getItem("refreshToken"));

        const res = await refreshToken(formData);

        if (res.accessToken) {
          localStorage.setItem("Authorization", res.accessToken);
          localStorage.setItem("refreshToken", res.refreshToken);
          localStorage.setItem("sxpt_timestamp", new Date().getTime());
        } else {
          console.log("刷新token失败");
          localStorage.setItem("isLogin", "false");
          localStorage.removeItem("Authorization");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("sxpt_timestamp");
          debounceMessage("登录已过期，请重新登录");
          setTimeout(() => {
            window.location.href = window.location.origin;
          }, 1000);
        }

        resolve();
      } catch (error) {
        console.error(error);
        // 处理错误情况
        reject(error);
      } finally {
        isExchangingToken = false;
      }
    });
    return exchangePromise;
  } catch (error) {
    return Promise.reject(error);
  }
};
const tokenTimeout = () => {
  return (
    (Date.now() - localStorage.getItem("sxpt_timestamp")) / 1000 / 60 >
    limitRefreshTokenMinutes
  );
};
// request拦截器
service.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("Authorization");
    if (
      token &&
      !config.url.includes("/login") &&
      !config.url.includes("refresh-token") &&
      tokenTimeout()
    ) {
      try {
        await handleExchangeToken(); // 等待 Token 交换完成
      } catch (error) {
        localStorage.setItem("sxpt_timestamp", new Date().getTime());
      }
    }
    if (config.requestType == "blob") config.timeout = undefined;
    config.headers["tenant-id"] = 0;
    const _token = localStorage.getItem("Authorization");
    if (token) config.headers.Authorization = `Bearer ${_token}`;
    return config;
  },
  (error) => {
    console.error(error);
    Promise.reject(error);
  }
);

const debounceMessage = debounce((msg) => {
  Message.error(msg);
}, 1000);
service.interceptors.response.use(
  (response) => {
    const { data: { code, status, data, msg } = {} } = response;
    if (status === "success" || code === 0 || code === 200) {
      return data;
    } else {
      if (code === 401) {
        debounceMessage("请重新登陆");
        localStorage.removeItem("Authorization");
        localStorage.removeItem("sxpt_timestamp");
        localStorage.removeItem("userInfo");
        store.dispatch("user/setUserInfo", null);
        if (!router.currentRoute.path.includes("/landing")) {
          router.push({ path: "/landing" });
        }
        // setTimeout(() => {
        //   window.location.reload(); // 浏览器刷新
        // }, 1000);
      } else {
        debounceMessage(msg || "请求失败");
        // Message.error(msg || "请求失败");
      }
      return Promise.reject(response.data);
    }
  },
  (e) => {
    const { status } = e.response || {};
    if (status === 404) {
      debounceMessage("请求404");
      // Message.error("请求404");
      // return store.dispatch('user/fedLogout')
    }
    if (status === 500) {
      debounceMessage("请求500服务器异常");
      // Message.error("请求500服务器异常");
      // return store.dispatch('user/fedLogout')
    }
    /* 处理接口超时 */
    if (e.message.includes("timeout")) {
      debounceMessage("请求超时");
      // Message.error("请求超时");
    }
    return Promise.reject(e);
  }
);

export default service;
